// OPERATORS
export enum ANY_OF_OPERATORS {
  is_any_of = "Is Any Of",
  is_not_any_of = "Is Not Any Of",
}

export enum EQUALS {
  equals = "Equals",
}

export enum EQUALITY_OPERATORS {
  equals = "Equals",
  does_not_equal = "Does Not Equal",
}

export enum EQUALITY_TIME_OPERATORS {
  on_or_before = "On or Before",
  on_or_after = "On or After",
}

export enum OVERLAP_OPERATORS {
  has_overlap = "Overlaps",
  does_not_overlap = "Does Not Overlap",
}

export enum SEARCH_OPERATORS {
  equals = "Equals",
  starts_with = "Starts With",
}

export enum SEARCH_STARTS_WITH_ANY_OF_OPERATORS {
  equals = "Equals",
  starts_with = "Starts With",
  any_of_starts_with = "Starts With Any Of",
}

export enum COMPARISON_OPERATORS {
  is_greater_than_or_equal = "Greater than or Equal",
  is_lesser_than_or_equal = "Less than or Equal",
}

export const OPERATORS = {
  ...ANY_OF_OPERATORS,
  ...EQUALITY_OPERATORS,
  ...EQUALITY_TIME_OPERATORS,
  ...COMPARISON_OPERATORS,
  ...OVERLAP_OPERATORS,
  ...SEARCH_OPERATORS,
  ...SEARCH_STARTS_WITH_ANY_OF_OPERATORS,
};

export enum EQUAL_OPERATORS {
  equals = "Equals",
  does_not_equal = "Does Not Equal",
}

export const NETWORK_OPERATORS = {
  ...ANY_OF_OPERATORS,
  ...EQUALITY_OPERATORS,
  ...COMPARISON_OPERATORS,
  ...OVERLAP_OPERATORS,
  ...SEARCH_STARTS_WITH_ANY_OF_OPERATORS,
};

export interface RuleCondition<T> {
  readonly operator?: OperatorValues;
  readonly selection: T;
  readonly value?: string | ReadonlyArray<string> | ReadonlyArray<number>;
}

export type OperatorValues = keyof typeof OPERATORS;
